module.exports = __webpack_public_path__ + "static/media/high-demand.3772bce7.svg";